import { FormField } from "../../../UI/DesignStandards";
import { NestedItemCard, NestedItemContent } from "../../../DesignSystem";

const PrizeFundDistributionItem = ({
  item,
  editMode,
  validationErrors,
  isPayoutFinalized,
  onPrizeAmountChange,
  isSubmitting,
}) => {
  return (
    <NestedItemCard
      className={item.isPrimary ? "border-brand-charcoal/20" : ""}
    >
      <NestedItemContent>
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <h3 className="font-medium text-brand-charcoal truncate">
                {item.eventName}
              </h3>
              {item.isPrimary && (
                <span className="inline-flex items-center bg-brand-charcoal text-brand-cream px-2 py-1 rounded-lg text-xs font-display font-bold">
                  Primary Event
                </span>
              )}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="text-right">
              <div className="text-sm text-brand-muted mb-1">Assigned Amount</div>
              {editMode ? (
                <FormField
                  type="number"
                  min="0"
                  step="0.01"
                  value={item.prizeAmount === 0 ? "" : item.prizeAmount || ""}
                  onChange={(e) => onPrizeAmountChange(item.id, e.target.value)}
                  className={`w-32 ${
                    validationErrors[item.id] ? "border-red-500" : ""
                  }`}
                  disabled={isPayoutFinalized || isSubmitting}
                  placeholder="0.00"
                />
              ) : (
                <div className="text-lg font-score font-semibold text-brand-charcoal">
                  ${parseFloat(item.prizeAmount || 0).toFixed(2)}
                </div>
              )}
            </div>
          </div>
        </div>
      </NestedItemContent>
    </NestedItemCard>
  );
};

export default PrizeFundDistributionItem;
